"use client"

import { Banner } from '@/app/components/Banner'
import { useServicesLinks } from '@/app/components/Nav/links'
import WhatWeOfferCard from '@/app/components/WhatWeOfferCard'
import { arrow } from '@/assets/imgs'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'


const Services = () => {
  const  t  = useTranslations()
  const servicesLinks = useServicesLinks()

  return (
    <>
      <Banner
        name={t('links.services')}
        className='bg-servicesBanner'
      />
      <div className={`flex flex-wrap justify-center gap-6 py-10`}>
        {servicesLinks.map((link, index) => (
          <WhatWeOfferCard
            key={index}
            description={link.description}
            title={link.title}
            url={link.url}
            img={link.img}
            className='flex-col  items-center justify-center text-center transition-all duration-300 shadow-md hover:shadow-2xl '
          />
        ))}
      </div>
      <div className='flex flex-col items-center gap-8 bg-linear-to-r from-secondary to-primary to-100% px-6 py-40 sm:px-14 md:px-16 lg:flex-row lg:gap-28'>
        <p className='flex text-center text-3xl font-bold text-white lg:text-left'>
          {t('mainServicesPage.growYourBusiness')}
        </p>
        <Image alt='arrow' src={arrow} className='hidden w-20 lg:block rtl:rotate-180' />

        <div className='flex basis-1/2 justify-center xl:basis-1/4'>
          <Link
            href='/contact-us'
            className='rounded-full bg-white px-10 py-4 font-semibold text-secondary transition-all duration-500 hover:bg-linear-to-r hover:from-primary hover:from-10% hover:to-secondary hover:text-white lg:mt-0'
          >
            {t('mainServicesPage.getInTouch')}
          </Link>
        </div>
      </div>
    </>
  )
}

export default Services
